import vars from '../_vars';


jQuery(document).ready(function ($) {
	"use strict";


	function overlayMenuArrows() {
		$('.sites_overlay--menu li').each(function () {
			var elemWidth = $(this).width();
			var menuItemLine = $(this).find('.line');
			var menuItemSvg = $(this).find('svg');
			var menuItemWidth = $(this).find('.menu_itm').width();
			var resultWidth = elemWidth - menuItemWidth;

			menuItemLine.animate({
				width: resultWidth - 20
			});
			menuItemSvg.animate({
				right: -resultWidth + 16
			});
		});
	}

	/**
	 * Toggle main menu
	 */
	$('.icon-burger').on('click', function () {
		$('html,body').toggleClass('is-menu-open');
		// $('.main-nav--footer .site-header__site_nav, .sites_overlay').removeClass('active');
		// $('.main-menu .menu-item-has-children').removeClass('active').find('.sub-menu').slideUp();
		$('.new_menu_overlay').addClass('active');
	});

	$('.new_menu_overlay--close').on('click', function () {
		$('.new_menu_overlay').removeClass('active');
	});

	$('.main-menu li:not(.menu-item-has-children) > a').on('click', function () {
		$('html,body').removeClass('is-menu-open');
	});

	$('.header_nav_click').on('click', function () {
		$('.main-nav--footer .site-header__site_nav').addClass('active');
		$('.sites_overlay').addClass('active');
		$('html,body').addClass('is-menu-open');
	});
	$('.sites_overlay__close, .new_menu_overlay--close').on('click', function () {
		$('.main-nav--footer .site-header__site_nav, .sites_overlay').removeClass('active');
		$('html,body').removeClass('is-menu-open');
	});
	$('.site-header__site_nav_btn').on('click', function () {
		$('.main-nav--footer .site-header__site_nav, .sites_overlay').toggleClass('active');
	});

	$('.site-header--right .search_icon').on('click', function () {
		$('.site-header').toggleClass('search_active');
		$('.search-form').toggleClass('active');
		// $(this).toggleClass('active');
	});

	// autoclose mobile menu when increasing window width
	function closeMobileMenu() {
		$('.main-menu .sub-menu, .footer-links .sub-menu').css('display', '');
		if ($(window).width() >= vars.bp.lg) {
			if ($('body').hasClass('is-menu-open')) {
				$('.icon-burger').trigger('click');
			}
		}
	}


	overlayMenuArrows();
	$(window).on('resize', function () {
		closeMobileMenu();
		overlayMenuArrows();
	});


	/**
	 * Toggle mobile sub menu
	 */
	$('.main-menu .menu-item-has-children .dropdown-toggle, .footer-links .menu-item-has-children').on('click', function (e) {
		const el = $(this).parent(),
			topEl = $(this).parent().parent();
		if ($(window).width() < vars.bp.lg) {
			e.stopPropagation();
			if (el.hasClass('active')) {
				el.removeClass('active');
				el.find('> .sub-menu').slideUp();
			} else {
				topEl.find('> .sub-menu').slideUp();
				topEl.find('.menu-item-has-children').removeClass('active');
				el.addClass('active');
				el.find('> .sub-menu').slideDown();
			}
		}
	});


	// console.log($(window).width() + ' = $(window).width()');
	// console.log(vars.bp.lg + ' = vars.bp.lg');

	if ($(window).width() < vars.bp.lg) {
		$('.new_main_menu .dropdown-toggle').on('click', function (e) {
			var colorClass;
			if ($(this).parent().data('color')) {
				colorClass = $(this).parent().data('color');
			} else {
				colorClass = 'color_f3f5f7';
			}
			$('.new_menu_overlay').addClass(colorClass);

			const el = $(this).parent();

			e.stopPropagation();
			el.addClass('active');

			$('.new_menu_overlay--header .back').addClass('active');
			$('.new_menu_overlay--header .site-logo').addClass('d-none');

			var linkText = el.children('a, span').text();
			$('.new_menu_overlay--header .back span').text(linkText);
		});
		$('.new_menu_overlay--header .back svg').on('click', function () {
			var $menuOverlay = $('.new_menu_overlay');

			if ($('.new_main_menu > li > .sub-menu > li').hasClass('active')) {
				var linkText = $('.new_main_menu > li.active > a').text();
				$('.new_menu_overlay--header .back span').text(linkText);

				$('.new_main_menu > li > .sub-menu > li').removeClass('active');
			} else {
				$('.new_main_menu > li').removeClass('active');
				$menuOverlay.attr('class', 'new_menu_overlay active');
				$('.new_menu_overlay--header .back').removeClass('active');
				$('.new_menu_overlay--header .site-logo').removeClass('d-none');
			}

		});
	} else {
		$('.new_main_menu > .menu-item-has-children, .new_bottom_menu > .menu-item-has-children').each(function () {

			var colorClass;
			if ($(this).data('color')) {
				colorClass = $(this).data('color');
			} else {
				colorClass = 'color_f3f5f7';
			}
			$(this).on("mouseenter", function () {
				$('.new_menu_overlay').addClass(colorClass);
			}).on("mouseleave", function () {
				$('.new_menu_overlay').removeClass(colorClass);
			});
		});
	}


	// in new main menu added title for sub-menus
	$('.new_main_menu__container, .new_bottom_menu__container').each(function () {
		const $menu = $(this);
		$menu.children('ul').each(function(){
			const $submenu = $(this);
			$submenu.children('.menu-item-has-children').each(function () {
				const $menuItem = $(this);
				const itemColor = $menuItem.attr('data-color');
				const thisTitle = $menuItem.children('a, span').text();
				const $submenuChildren = $menuItem.children('ul');

				$submenuChildren.prepend(`<li class="menu_title visible-lg-up ${itemColor}">${thisTitle}</li>`);

				$submenuChildren.find('.menu-item-has-children').each(function () {
					const $childItem = $(this);
					const childTitle = $childItem.children('a, span').text();
					$childItem.children('ul').prepend(`<li class="menu_title visible-lg-up ${itemColor}">${childTitle}</li>`);
				});
			});
		});


		// opened menu on current pages
			$(this).find('.current_page_item, .current-menu-item').closest('.current-menu-ancestor').addClass('item_active');
	});

	if ($('body').attr('data-current-site') === '1' && $('body').hasClass('home')) {
		$('.new_menu_overlay--body .new_main_menu>li>.sub-menu>li')
			.removeClass('current_page_item')
			.removeClass('current-menu-item');
	}

	$('.new_menu_overlay--body nav').mouseenter(function(){
		$('.new_main_menu__container ul > li, .new_bottom_menu__container ul > li').removeClass('item_active');
	});





	if ('ontouchstart' in document.documentElement) {
		$('.new_main_menu').addClass('touch_device').find('.menu-item-has-children').each(function () {
			$(this).children('a').each(function (index, el) {
				$(el).on('click', function (e) {
					e.preventDefault();
				});
			});
		});
	}

});
